import { render, staticRenderFns } from "./popup-categories.vue?vue&type=template&id=7627aa39&"
import script from "./popup-categories.vue?vue&type=script&lang=js&"
export * from "./popup-categories.vue?vue&type=script&lang=js&"
import style0 from "./popup-categories.vue?vue&type=style&index=0&id=7627aa39&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports